import { render, staticRenderFns } from "./PacienteSalaEsperaModal.vue?vue&type=template&id=e84d3c82&scoped=true"
import script from "./PacienteSalaEsperaModal.vue?vue&type=script&lang=js"
export * from "./PacienteSalaEsperaModal.vue?vue&type=script&lang=js"
import style0 from "./PacienteSalaEsperaModal.vue?vue&type=style&index=0&id=e84d3c82&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84d3c82",
  null
  
)

export default component.exports